import React from "react";

const BELIEFS = [
  { title: "Documentation should reflect what your lab actually does.", body: "If there's a gap between your SOPs and your actual practice, closing it is more valuable than having beautiful paperwork." },
  { title: "AI-generated content is a draft, not a final document.", body: "Every output from LabComplyx requires human review and approval before it becomes a controlled document. We will never position AI as a substitute for qualified professional judgment." },
  { title: "Small labs deserve the same documentation quality as large ones.", body: "CLIA and CAP requirements do not scale down for a 10-person lab. Our job is to make compliance work manageable at that scale." },
  { title: "We will tell you when LabComplyx is not the right fit.", body: "If your lab needs a full enterprise QMS, we will say so. If your inspection needs something we cannot deliver in the available time, we will say that too." },
];

export default function Beliefs() {
  return (
    <section className="py-14 bg-muted/50 border-y border-border">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl font-extrabold text-brand-navy text-center mb-8">What we believe</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {BELIEFS.map((b) => (
            <div key={b.title} className="bg-card border border-border border-l-4 border-l-brand-teal rounded-[10px] p-6">
              <h3 className="text-base font-bold text-brand-navy mb-2">{b.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{b.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}